import style from "../../style/Commit.module.scss";
import className from "classnames/bind";
import {useState, useEffect} from "react";
import {Modal, Row, Skeleton} from "antd";
import _ from "lodash";
import ActionBar from "~/layout/ActionBar";
import {
    Loading,
    Icon,
} from "~/components";
import {
    apiError,
    handleRequest,
    numberFormat
} from "~/utils";
import {
    reportApi,
} from "~/api";
import {useGroup} from "../../../../hooks";
import {SaleCommitDetail, SaleCommitSearch, SaleCommitTable} from "../../components";
import {saleApi} from "../../../../api";

const cn = className.bind(style);

function CommitReport() {

    const listGroup = useGroup();

    const [loading, setLoading] = useState(false);

    const [loadingDetail, setLoadingDetail] = useState(false);

    const [filter, setFilter] = useState({
        success: false,
        detail: ['user']
    });

    const [reportDataTotal, setReportDataTotal] = useState([]);

    const [reportDataTable, setReportDataTable] = useState([]);

    const [reportDataDetail, setReportDataDetail] = useState([]);

    const [openModal, setOpenModal] = useState({
        detail : false,
    });

    const handleModalOpen = (modal) => {
        openModal[modal] = true;
        setOpenModal({...openModal})
    }

    const handleModalClose = (modal) => {
        openModal[modal] = false;
        setOpenModal({...openModal});
    }

    const handleLoad = async () =>
    {
        setLoading(true);

        let [error, response] = await handleRequest(reportApi.saleCommit(filter));

        let message = apiError(`Lấy thông tin báo cáo thất bại`, error, response);

        if (!message)
        {
            setReportDataTotal(response.data.total)
            setReportDataTable(response.data.table)
        }

        setLoading(false);
    }

    const handleClickDetail = async (groupId) =>
    {
        setLoadingDetail(true);

        let [error, response] = await handleRequest(saleApi.commitGets({
            group: groupId,
            time: filter.time,
            detail:['user']
        }));

        let message = apiError(`Lấy thông tin báo cáo thất bại`, error, response);

        if (!message)
        {
            setReportDataDetail(response.data)
        }

        setLoadingDetail(false);
    }

    //Load data
    useEffect(() => {
        handleLoad().then();
    }, [filter]);

    //Search
    const handleFilterChange = (key, value) =>
    {
        setFilter({
            ...filter,
            [key]: value
        });
    };

    return (
        <>
            <ActionBar title={'Công nợ'}></ActionBar>
            <div className="container d-block">
                <div className="content pd-1" style={{overflow:'auto'}}>
                    <SaleCommitSearch filter={filter} listGroup={listGroup} onChange={handleFilterChange}/>
                    {
                        loading && <Loading noFixed spin={true} />
                    }
                    {
                        !loading && <Row gutter={10}>
                            <div className={cn('item-gird', 'pd-1')}>
                                {
                                    !_.isEmpty(reportDataTotal) && reportDataTotal.map((item) => {
                                        return (
                                            <div key={item.key} className={cn('item', 'item-'+item.badge)}>
                                                <div className={cn('icon')}>{Icon.plusCircle}</div>
                                                <div className={cn('info')}>
                                                    <h3>{item.name}</h3>
                                                    <p>{numberFormat(item.value)}</p>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </Row>
                    }
                </div>
                <div className="content pd-1" style={{overflow:'auto'}}>
                    {
                        loading && <Loading noFixed spin={true} />
                    }
                    {
                        !loading && <SaleCommitTable
                            items={reportDataTable}
                            filter={filter}
                            onDetail={handleClickDetail}
                            onModalOpen={handleModalOpen}
                        />
                    }
                </div>
            </div>
            {
                <Modal width={1000} title="Chi tiết cam kết" visible={openModal.detail} onCancel={() => {handleModalClose('detail')}}>
                    {loadingDetail && <Skeleton />}
                    {(!loadingDetail && !_.isEmpty(reportDataDetail)) && <SaleCommitDetail items={reportDataDetail} />}
                </Modal>
            }
        </>
    )
}

export default CommitReport;